var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 156.5,
    viewBox: "0 0 9 156.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083",
    transform: "translate(-154 -1362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    y2: 148.5,
    transform: "translate(158.5 1369)",
    fill: "none",
    stroke: "rgba(255,255,255,0.5)",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: "0 5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    transform: "translate(154 1362)",
    fill: "#848484"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarShort);
export default __webpack_public_path__ + "static/media/sidebar_short.6e7c32947ea46365b296b28276797e9e.svg";
export { ForwardRef as ReactComponent };